<template>
  <dl :class="$style.filter_bar">
    <dt :class="$style.filter_bar_label">{{ name }}</dt>
    <dd :class="$style.filter_bar_content">
      <div  :class="[$style.all_wraper, {
        'is-checked': isAll
      }]">
        <v-checkbox :value="isAll" @input="$emit('on-clear')">不限</v-checkbox>
        <!-- <span class="all-btn" @click="$emit('on-clear')">不限</span> -->
      </div>
      <div :class="$style.filter_bar_list">
        <div v-for="(option, index) in computedOptions" :key="index" :class="$style.filter_bar_item" :style="{ width: itemWidth }">
          <slot name="item" :option="option" />
        </div>
        <el-button v-if="options.length > this.count && !expanded" :class="$style.moreBtn" size="mini"
          @click="expanded = true">更多<i class="ficon ficon-arrow-bottom" /></el-button>
      </div>
    </dd>
  </dl>
</template>

<script>
import { defineComponent } from '@nuxtjs/composition-api'
export default defineComponent({
  name: 'Filterbar',
  props: {
    isAll: {
      type: Boolean,
      default: true,
    },
    name: {
      type: String,
      default: "",
    },
    options: {
      type: Array,
      default: () => [],
    },
    count: {
      type: Number,
      default: 6,
    },
  },
  data() {
    return {
      expanded: false,
    };
  },
  computed: {
    computedOptions() {
      return this.expanded ? this.options : this.options.slice(0, this.count);
    },
    itemWidth() {
      return 100 / this.count + "%";
    },
  },
});
</script>

<style lang="scss" module>

// @import "~@/assets/scss/base/_color";

.filter {
  &_bar {
    --label-width: 4.5em;
    display: flex;
    line-height: 20px;

    &_label {
      // float: left;
      width: var(--label-width);
      color: $important-text-color;
      margin-top: 7px;
      margin-right: 20px;
      font-size: var(--label-font-size);
    }

    &_content {
      flex: 1;
      display: flex;
      margin-left: 20px;

      .all_wraper {
        flex-basis: 90px;
        margin-top: 7px;
      }
    }

    &_list {
      flex: 1;
      position: relative;
      display: flex;
      padding-right: 120px;
      flex-wrap: wrap;

      .moreBtn {
        position: absolute;
        right: 0;
        padding: 4px 8px;
        top: 0;
        // color: $secondary-text-color;
        display: inline-flex;
        align-items: center;
        margin-top: 3px;
        border: 1px solid #191919;
        // margin-right: 20px;
      }
    }

    &_item {
      padding: 0 10px;
      width: 16%;
      margin-top: 7px;
      margin-bottom: 7px;
      box-sizing: border-box;
    }
  }
}

</style>
